import React from 'react';
import { Link as ChakraLink } from '@chakra-ui/react';
import { Link as GatsbyLink } from 'gatsby';
import { useSeoMeta } from '../../hooks/useSeoMeta';

const trustedLinks = [process.env.GATSBY_SITE_URL];

const Link = ({ href = ``, isExternal = false, children = null, ...props }) => {
  const {
    site: {
      siteMetadata: { language }
    }
  } = useSeoMeta();

  const isRelative =
    (href && href.indexOf(`/`) === 0) ||
    new RegExp(`(${trustedLinks.join(`|`)})`).test(href);

  return isRelative ? (
    <ChakraLink
      as={GatsbyLink}
      to={href}
      activeClassName="is-active"
      hrefLang={language.toLowerCase()}
      {...props}>
      {children}
    </ChakraLink>
  ) : (
    <ChakraLink
      href={href}
      isExternal={isExternal}
      rel="nofollow"
      hrefLang={language.toLowerCase()}
      {...props}>
      {children}
    </ChakraLink>
  );
};

export default Link;
